const UserTypes = {
	GET_USERS: 'GET_USERS',
	DELETE_USER: 'DELETE_USER',
}

export default UserTypes
